// extracted by mini-css-extract-plugin
export var activeFilterButton = "_mc-c";
export var backButton = "_mc-4";
export var backIcon = "_mc-5";
export var chevronShortcut = "_mc-6";
export var container = "_mc-1";
export var editor = "_mc-8";
export var editorWrapper = "_mc-7";
export var prefix = "_mc-2";
export var searchIcon = "_mc-3";
export var suffix = "_mc-9";
export var suffixContent = "_mc-a";
export var suffixText = "_mc-b";
export var wrapper = "_mc-0";